export default (cb) => {
  if (window.location.hash) {
    const url = window.location.hash.split('/')
    url.shift()
    const [area, ...params] = url
    cb(area, params)
  }
}
